import { render, staticRenderFns } from "./ProductLabelQuestion.vue?vue&type=template&id=dcf6e15a&scoped=true&"
import script from "./ProductLabelQuestion.vue?vue&type=script&lang=js&"
export * from "./ProductLabelQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ProductLabelQuestion.vue?vue&type=style&index=0&id=dcf6e15a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf6e15a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VFileInput,VSelect,VTextField})
